package com.sweetlime.bingeamigo.state

import com.sweetlime.bingeamigo.model.TvShow

sealed class TvShowState {
    data class Success(val shows: List<TvShow>) : TvShowState()
    data class Error(val message: String) : TvShowState()
    data object Loading : TvShowState()
    data object Idle : TvShowState()
}